import { useState, useEffect, useRef } from "react";
import bidService from "./bidService";

export default function usePrebidBidding(adUnitId) {
  const [bidData, setBidData] = useState({
    winningAd: null,
    bidder: null,
    cpm: null,
    isVideo: false,
  });
  
  const isMountedRef = useRef(true);
  
  useEffect(() => {
    if (!adUnitId) return;
    
    isMountedRef.current = true;
    
    // Create handler that updates state only when component is mounted
    const handleBidUpdate = (data) => {
      if (isMountedRef.current) {
        setBidData(prev => {
          // Only update if something changed
          if (
            prev.winningAd === data.winningAd &&
            prev.cpm === data.cpm &&
            prev.bidder === data.bidder &&
            prev.isVideo === data.isVideo
          ) {
            return prev;
          }

          return data; 
        });
      }
    };
    
    // Subscribe to bid updates for this ad unit
    const unsubscribe = bidService.subscribe(adUnitId, handleBidUpdate);
    
    return () => {
      isMountedRef.current = false;
      unsubscribe();
    };
  }, [adUnitId]);
  
  return bidData;
}